import {initAutoplayVideo} from '../_extras/video-autoplay';

export function initContentVideo(block) {
	const video = block.querySelector('video.content-video__media');
	if (!video) return false;

	if (video.hasAttribute('data-autoplay')) initAutoplayVideo(video, 'content-video__toggle');

	return true;
}

export default function contentVideoBlock(options = {}) {
	try {
		const {block} = options;

		if (!block || block.dataset.contentVideoReady === 'true') return;
		if (!initContentVideo(block)) return;

		block.dataset.contentVideoReady = 'true';
	} catch (error) {
		console.error(error);
	}
}
